// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_sp_input_container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
  width: 100%;
}

.search_sp_input_container input {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 10px 15px;
  border-radius: 4px;
  width: 90%;
}

.search_sp_picture {
  width: 32px;
  height: 32px;
}



.search_sp_container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
  width: 100%;
}

.search_sp_container input {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 10px 15px;
  border-radius: 4px;
  width: 90%;
}

.search_sp_selected {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
  background-color: var(--bg);
  width: 90%;
}

.search_sp_not_selected {
  max-width: 100%;
  width: 95%;
  padding: 5px 10px;
  border-radius: 4px;

}

.search_sp_not_selected:hover{
  border: 1px solid var(--border);
  background-color: rgb(242, 243, 252, 0.2);
}

.search_sp_selected p,
.search_sp_not_selected p {
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.search_sp_list_box {
  position: absolute;
  background-color: var(--bg-card);
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 150px;
  overflow-y: scroll;
  width: 100%;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 4px;
  width: 90%;
}

.input_selectedSp {
  position: relative;
}

.search_sp_relative {
  position: relative;
}

.search_sp_delete_item_select {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.search_sp_item_select_ticker {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px
}`, "",{"version":3,"sources":["webpack://./src/components/SearchStructuredProducts/SearchStructuredProducts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;AACJ","sourcesContent":[".search_sp_input_container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 15px;\n  width: 100%;\n}\n\n.search_sp_input_container input {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 10px 15px;\n  border-radius: 4px;\n  width: 90%;\n}\n\n.search_sp_picture {\n  width: 32px;\n  height: 32px;\n}\n\n\n\n.search_sp_container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 15px;\n  width: 100%;\n}\n\n.search_sp_container input {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 10px 15px;\n  border-radius: 4px;\n  width: 90%;\n}\n\n.search_sp_selected {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n  background-color: var(--bg);\n  width: 90%;\n}\n\n.search_sp_not_selected {\n  max-width: 100%;\n  width: 95%;\n  padding: 5px 10px;\n  border-radius: 4px;\n\n}\n\n.search_sp_not_selected:hover{\n  border: 1px solid var(--border);\n  background-color: rgb(242, 243, 252, 0.2);\n}\n\n.search_sp_selected p,\n.search_sp_not_selected p {\n  margin: 0;\n  padding: 0;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.search_sp_list_box {\n  position: absolute;\n  background-color: var(--bg-card);\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 150px;\n  overflow-y: scroll;\n  width: 100%;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  width: 90%;\n}\n\n.input_selectedSp {\n  position: relative;\n}\n\n.search_sp_relative {\n  position: relative;\n}\n\n.search_sp_delete_item_select {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  background-color: var(--primary);\n  border-radius: 50%;\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.search_sp_item_select_ticker {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
